import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdminCheckBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	stroke: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		fill: "currentColor",
		cx: 14,
		cy: 14,
		r: 12
	}), /* @__PURE__ */ _jsx("polygon", {
		fill: "#FFFFFF",
		points: "12.87 19.91 7.91 14.75 9.64 13.09 12.7 16.26 18.28 9.17 20.17 10.66 12.87 19.91"
	})]
});
export default SvgAdminCheckBadge;
